import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import Layout from '../../components/common/Layout';

const ThankYou: React.FC = () => {
  return (
    <Layout>
      <div className="flex flex-col flex-grow items-center justify-center text-center py-12">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
          <div className="w-24 h-24 bg-contessa-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle size={48} className="text-contessa-600" />
          </div>
          <h1 className="text-4xl font-serif font-bold text-contessa-800 mb-4">
            ¡Gracias por tu mensaje!
          </h1>
          <p className="text-contessa-600 text-lg mb-8">
            He recibido tu consulta correctamente. A la brevedad te contactaré para confirmar la fecha y hora.
          </p>
          <Link
            to="/"
            className="bg-contessa-600 hover:bg-contessa-700 text-white font-bold py-3 px-8 rounded-lg transition-colors duration-300"
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default ThankYou; 